import React, { useContext, useEffect, useState } from 'react';
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table'

import './T_R_table.css'
import {LDRTableFactory, componentsNamesFactoryForTitle } from '../../Helper_functions/Languages/LanguageSelector';

// import context
import {LanguageContext} from "../../context/languageContext";
import { LanguageIdContext } from '../../context/languageIdContext';
interface Table_Int{
    percent_1:number,
    percent_2:number,
    percent_3:number,
    percent_4:number
}



export function T_R_table({percent_1,percent_2,percent_3,percent_4}:Table_Int) {
  // import context
  
  const {language} = useContext(LanguageContext);
  const {languageId} = useContext(LanguageIdContext);

    let i = 0;
    const [colSelected, setColSelected] = useState(1);
    

    
    useEffect(() => {
        let largest_num = Math.max(percent_1,percent_2,percent_3,percent_4)
        
        if(largest_num == percent_1){
            
            setColSelected(1);
        }
        if(largest_num == percent_2){
            setColSelected(2);
        }
        if(largest_num == percent_3){
            setColSelected(3);
        }
        if(largest_num == percent_4){
            setColSelected(4);
        }
        
    }, [colSelected,language])


    return (
      <Table className = "table table-bordered" key={language}>
        <Thead>
          <Tr>
            <Th scope="col"></Th>
            

            <Th scope="col">{componentsNamesFactoryForTitle(languageId,"Limited")}</Th>
            <Th scope="col">{componentsNamesFactoryForTitle(languageId,"Shifting")}</Th>
            <Th scope="col">{componentsNamesFactoryForTitle(languageId,"Shifted")}</Th>
            <Th scope="col">{componentsNamesFactoryForTitle(languageId,"Widespread")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {/* 
          <Row c1={"Better Use of Available Scriptures"} c2={"Possibly"}     c3={"Yes"}          c4={`Yes`}        c5={"Yes"} Colum_selected={colSelected}/>*/}
          {LDRTableFactory(languageId).map(element => {
            return  <Row c1={element.title} c2={element.limited} c3={element.shifting} c4={element.shifted} c5={element.widespread} Colum_selected={colSelected}/>
          })}
        </Tbody>
      </Table>
    );
  }
  
  
  interface Row_int{
    c1:string,
    c2:string,
    c3:string,
    c4:string,
          c5:string,
    Colum_selected:number
  }
  const Row = ({
    c1,
    c2,
    c3,
    c4,
    c5,
    Colum_selected,
  }: Row_int): JSX.Element => {
    switch (Colum_selected) {
      case 1:
        return (
          <Tr className="">
            <Td><b>{c1}</b></Td>
            <Td className="table-light">{c2}</Td>
            <Td>{c3}</Td>
            <Td>{c4}</Td>
            <Td>{c5}</Td>
          </Tr>
        );
      case 2:
        return (
          <Tr className="">
            <Td><b>{c1}</b></Td>
            <Td >{c2}</Td>
            <Td className="table-light">{c3}</Td>
            <Td>{c4}</Td>
            <Td>{c5}</Td>
          </Tr>
        );
      case 3:
        return (
          <Tr className="">
            <Td><b>{c1}</b></Td>
            <Td >{c2}</Td>
            <Td>{c3}</Td>
            <Td className="table-light">{c4}</Td>
            <Td>{c5}</Td>
          </Tr>
        );
      case 4:
        return (
          <Tr className="">
            <Td><b>{c1}</b></Td>
            <Td >{c2}</Td>
            <Td>{c3}</Td>
            <Td>{c4}</Td>
            <Td className="table-light">{c5}</Td>
          </Tr>
        );

      default:
        return (
          <Tr className="">
            <Td><b>{c1}</b></Td>
            <Td className="table-light">{c2}</Td>
            <Td>{c3}</Td>
            <Td>{c4}</Td>
            <Td>{c5}</Td>
          </Tr>
        );
    }
  };
